import { useRef, useState } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { ChevronsRight, Loader2 } from "lucide-react";

export default function SwipeButton({ label = "Geser untuk ambil pesanan", onConfirm, testid = "swipe-accept-order", color = "bg-amber-500" }) {
  const track = useRef(null);
  const x = useMotionValue(0);
  const [busy, setBusy] = useState(false);
  const opacity = useTransform(x, [0, 160], [1, 0]);

  const onDragEnd = async () => {
    const max = (track.current?.offsetWidth || 300) - 56;
    if (x.get() > max * 0.8) {
      animate(x, max);
      setBusy(true);
      try {
        await onConfirm();
      } finally {
        setBusy(false);
        animate(x, 0);
      }
    } else {
      animate(x, 0, { type: "spring", stiffness: 400, damping: 30 });
    }
  };

  return (
    <div ref={track} data-testid={testid} className={`relative h-14 ${color} rounded-2xl p-1 overflow-hidden select-none shadow-md`}>
      <motion.span style={{ opacity }} className="absolute inset-0 grid place-items-center text-white font-bold text-sm pointer-events-none">
        {busy ? "Memproses..." : label}
      </motion.span>
      <motion.div data-testid={`${testid}-handle`} drag={busy ? false : "x"} dragConstraints={track} dragElastic={0} dragMomentum={false}
        style={{ x }} onDragEnd={onDragEnd}
        className="relative z-10 h-12 w-12 rounded-xl bg-white grid place-items-center cursor-grab active:cursor-grabbing shadow">
        {busy ? <Loader2 className="w-5 h-5 animate-spin text-slate-700" /> : <ChevronsRight className="w-6 h-6 text-slate-800" />}
      </motion.div>
    </div>
  );
}
